import * as React from "react";
import { Grid, Header, Icon } from "semantic-ui-react";

import { AppointmentPercentages } from "../model";

interface Props {
    appointmentPercentages: AppointmentPercentages;
}

export const ReferralAppointmentTypesStatistics: React.FC<Props> = (props: Props) => {
    return (
        <>
            <Header textAlign="center" as="h1">Referral Appointment Types</Header>
            <Grid>
                <Grid.Row columns={2}>
                    <Grid.Column>
                        <Header>
                            <Icon name="video" />
                            <Header.Content>Video</Header.Content>
                        </Header>
                    </Grid.Column>
                    <Grid.Column>{props.appointmentPercentages.video.toFixed(0)}%</Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2}>
                    <Grid.Column>
                        <Header>
                            <Icon name="phone" />
                            <Header.Content>Telephone</Header.Content>
                        </Header>
                    </Grid.Column>
                    <Grid.Column>{props.appointmentPercentages.telephone.toFixed(0)}%</Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2}>
                    <Grid.Column>
                        <Header>
                            <Icon name="users" />
                            <Header.Content>Face to Face</Header.Content>
                        </Header>
                    </Grid.Column>
                    <Grid.Column>{props.appointmentPercentages.faceToFace.toFixed(0)}%</Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    );
};
